export function formatHours(totalHours: number | string) {
  if (typeof totalHours == "string") {
    totalHours = Number.parseFloat(totalHours);
  }
  const hours = Math.floor(totalHours);
  const minutes = Math.round((totalHours - hours) * 60);
  const formattedTotalHours = `${hours}t, ${minutes}m`;
  return formattedTotalHours;
}
